const sessionTypes = {
	LIVE_SESSION: '0',
	HOMEWORK: '1',
	EMBED: '2',
	EMBED_NUMBER: 2, // TODO: this needs a better solution, but for now we don't want to change back end. Too many validations to do.
	PREVIEW: '3',
	TEACHER_STUDENT_VIEW: '4',
	CANVAS: '5',
}

const playableSessionTypes = [
	sessionTypes.LIVE_SESSION,
	sessionTypes.HOMEWORK,
	sessionTypes.TEACHER_STUDENT_VIEW,
	sessionTypes.CANVAS,
]

const previewSessionTypes = [sessionTypes.EMBED, sessionTypes.EMBED_NUMBER, sessionTypes.PREVIEW]

export default sessionTypes

export { playableSessionTypes, previewSessionTypes }
